module.exports = __webpack_public_path__ + "static/img/icon-notice.bda5361b.svg";